/*
 * @Description:
 * @Author: fal
 * @Date: 2025-07-18 17:02:07
 * @FilePath: \xhlz_pc\src\store\index.js
 * @LastEditTime: 2025-11-06 14:17:09
 */
import Vue from 'vue';
import Vuex from 'vuex';
import tagsView from './modules/tagsView';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isAlertShown: false, // 标志位，默认为false，表示提示框还没有被弹出,
    endDay: '',
    searchObj: null,
    activeNav: null,

    activeMenu: '',
    isCollapse: false, // 菜单是否收起
  },
  modules: {
    tagsView,
  },
  mutations: {
    showAlert(state) {
      state.isAlertShown = true;
    },
    hideAlert(state) {
      state.isAlertShown = false;
    },
    setSesrchContent(state, data) {
      state.searchObj = data;
    },
    setActiveNav(state, data) {
      state.activeNav = data;
    },

    set_activeMenu(state, value) {
      state.activeMenu = value;
    },
    set_collapse(state, value) {
      state.isCollapse = value;
    },
    // 清除所有数据
    clearAll(state) {
      state.activeMenu = '';
      state.isCollapse = false;
      state.searchObj = null;
      state.activeNav = null;
      tagsView.state.visitedViews = [];
      tagsView.state.cachedViews = [];
    },
  },

  actions: {
    // 设置当前活动菜单的路由path
    setActiveMenu({ commit }, value) {
      commit('set_activeMenu', value);
    },
    // 设置侧边栏是否显示
    setCollapse({ commit }, value) {
      commit('set_collapse', value);
    },
  },
});
